import useAccountQuery from '@/hooks/useAccountQuery';
import { getFlags } from '@/services/webApi';
import { useQuery } from '@tanstack/react-query';

export default function useFlagsQuery() {
  const accountQuery = useAccountQuery();

  return useQuery({
    enabled: !accountQuery.isLoading,
    queryKey: ['flags', accountQuery.data?.data.id],
    retry: false,
    queryFn: getFlags,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false
  });
}
